import type { AttentionItem } from "../types";

// UI-owned presentation copy for Action Center items, keyed by the same `id`
// the backend sends. Backend only sends the dynamic facts (id, severity,
// metric) so wording/routing can be tweaked here without a backend release.
export const attentionItemCatalog: Record<string, Pick<AttentionItem, "label" | "detail" | "actionLabel" | "route">> = {
  "last-year-dues": {
    label: "Students with previous year dues",
    detail: "Impacts school operations.",
    actionLabel: "Review dues",
    route: "/app/fees/previous-year-dues",
  },
  "low-attendance-students": {
    label: "Students below 75% attendance this month",
    detail: "Reduces school performance.",
    actionLabel: "View report",
    route: "/app/attendance/reports",
  },
  "pending-admissions": {
    label: "Admission enquiries awaiting review",
    detail: "Oldest enquiry pending 4 days.",
    actionLabel: "Review enquiries",
    route: "/app/enquiries",
  },
  "faculty-leave": {
    label: "Faculty leave requests pending",
    detail: "Waiting for your approval.",
    actionLabel: "Review requests",
    route: "/app/staff/leave",
  },
  "uncovered-today": {
    label: "Periods not covered today",
    detail: "Faculty on leave with no substitute.",
    actionLabel: "Assign substitutes",
    route: "/app/staff/substitutions",
  },
};
